import Pone from '~image/portfolio/portfolio-mas-1.jpg'
import Ptwo from '~image/portfolio/portfolio-mas-2.jpg'
import Pthree from '~image/portfolio/portfolio-mas-3.jpg'
import Pfour from '~image/portfolio/portfolio-mas-6.jpg'
import Pfive from '~image/portfolio/portfolio-mas-13.jpg'
import Psix from '~image/portfolio/portfolio-mas-4.jpg'

const portfolioData = [
    {
        image:Pone,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"1",
        tagName: ["all","design","seo"]
    },
    {
        image:Ptwo,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"2",
        tagName: ["all","marketing","development"]
    },
    {
        image:Pthree,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"3",
        tagName: ["all","design","marketing"]
    },
    {
        image:Pfour,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"4",
        tagName: ["all","seo"]
    },
    {
        image:Pfive,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"6",
        tagName: ["all","design"]
    },
    {
        image:Psix,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"6",
        tagName: ["all","design"]
    },
]
export default portfolioData;